module.exports = __webpack_public_path__ + "img/grafica.9997607d.png";